import { searchParam } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { CalculationPrintPage } from '@/areas/calculations/ProjectCalculation/QuotationExport/CalculationPrintablePage';
import { calculationViewModulePermissions, canViewCalculation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/calculation/print')({
    staticData: {
        access: { permissions: canViewCalculation, modulePermissions: calculationViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: z.object({
        validUntil: z.string(),
        customText: z.string().optional(),
        additionalLeadTimeDays: searchParam.number('required'),
        quotationNumber: z.string(),
        footerRight: z.string().optional(),
        footerLeft: z.string().optional(),
        footerCenter: z.string().optional(),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const customText = Route.useSearch({ select: (search) => search.customText });
    const validUntil = Route.useSearch({ select: (search) => search.validUntil });
    const additionalLeadTimeDays = Route.useSearch({ select: (search) => search.additionalLeadTimeDays });
    const quotationNumber = Route.useSearch({ select: (search) => search.quotationNumber });
    const footerLeft = Route.useSearch({ select: (search) => search.footerLeft });
    const footerRight = Route.useSearch({ select: (search) => search.footerRight });
    const footerCenter = Route.useSearch({ select: (search) => search.footerCenter });
    return (
        <CalculationPrintPage
            {...pathParams}
            customText={customText}
            validUntil={validUntil}
            additionalLeadTimeDays={additionalLeadTimeDays}
            quotationNumber={quotationNumber}
            footerLeft={footerLeft}
            footerRight={footerRight}
            footerCenter={footerCenter}
        />
    );
}
